module.exports = __webpack_public_path__ + "img/pomegranate.afca33da.png";